/* eslint-disable @nx/enforce-module-boundaries */
import { useInfiniteQuery, useMutation } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import {
  createGlobalCompanies,
  createGlobalJobTitles,
  getGlobalCompanies,
  getGlobalJobTitles,
} from 'v4/store/actions/global.data.actions';
import { getNextPageFromURL } from 'v4/utils/utils';

export const useJobTitles = ({ search, enabled = true }) => {
  const dispatch = useDispatch();
  const tid = useRef(-1);

  useEffect(() => {
    // Always fetch data, not just when search has length
    clearTimeout(tid.current);
    tid.current = setTimeout(() => {
      refetch?.();
    }, 300);
  }, [search]);

  const {
    mutateAsync,
    mutate,
    isLoading: createLoading,
  } = useMutation({
    mutationKey: ['global-job-titles-create', search],
    mutationFn: async (payload) => {
      return dispatch(createGlobalJobTitles(payload));
    },
    onSuccess: () => {
      refetch();
    },
  });
  const {
    isLoading,
    isFetching,
    data = { pages: [] },
    fetchNextPage,
    refetch,
  } = useInfiniteQuery({
    queryKey: ['global-job-titles', search],
    queryFn: async ({ queryKey }) => {
      const result = await dispatch(getGlobalJobTitles({ search: queryKey?.[1] }));
      return result?.payload;
    },
    getNextPageParam: (lastPage, pages) => {
      if (lastPage?.next) {
        return getNextPageFromURL(lastPage?.next);
      }
      return undefined;
    },
    refetchOnWindowFocus: false,
    enabled,
  });

  return {
    isLoading: isFetching,
    createLoading,
    data,
    fetchNextPage,
    refetch,
    search,
    mutate,
    mutateAsync,
  };
};